import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Menu, Image } from 'semantic-ui-react';
import Link from '../../../../lib/components/link';
import { GO_HOME } from '../../../../store/actions/home.types';
import SignedInSubMenu from './SignedInSubMenu';
import SignedOutSubMenu from './SignedOutSubMenu';
import { goLogin, logoutAction } from '../../../../store/actions/auth.actions';
import classes from './desktopHeader.css';
import logo from '../../../../assets/images/huddle-logo.svg';
import usaTodayLogo from '../../../../assets/images/usa-today-sports-color-horizontal-rgb.svg';

// const log = debug('huddle:app:nav:desktop');

const DesktopHeader = ({ isLoggedIn, userName, login, logout }) => (
  <Menu secondary className={classes.menu}>
    <div>
      <a href="http://thehuddle.com">
        <div>
          <Image src={logo} className={classes.huddleLogo} />
        </div>
      </a>
      <div className={classes.orangeLogoUnderline} />
    </div>
    {isLoggedIn
       ? <SignedInSubMenu logout={logout} userName={userName} />
       : <SignedOutSubMenu login={login} />}
    <div>
      <Image src={usaTodayLogo} alt="logo" className={classes.usaTodayLogo} href="https://www.usatoday.com/sports/" />
    </div>
  </Menu>
);

DesktopHeader.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  login: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  userName: PropTypes.string,
};

DesktopHeader.defaultProps = {
  userName: '',
};

const mapStateToProps = state => ({
  userName: state.auth.user ? state.auth.user.fname : '',
});

const mapDispatchToProps = dispatch => ({
  login: () => dispatch(goLogin),
  logout: () => dispatch(logoutAction),
});

const ConnectedDesktopHeader = connect(mapStateToProps, mapDispatchToProps)(DesktopHeader);

export default ConnectedDesktopHeader;



// WEBPACK FOOTER //
// ./src/app/components/Header/DesktopHeader/DesktopHeader.js